import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ShopsApiAdapter } from '../adapters/ShopsApiAdapter';
import { Filters } from '../models/Shops';
import { Service } from '../services/Service';

export const useShops = (filters: Filters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new ShopsApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['shops', filters],
    queryFn: ({ pageParam = 1 }) =>
      service.getPaginated({
        ...filters,
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    placeholderData: (previousData) => previousData, // 🎯 Mantener datos previos visibles durante refetch
    staleTime: 5 * 60 * 1000,
  });

  const shops = data?.pages.flatMap((page) => page.shops) ?? [];

  // Obtener el total del API (siempre sera el mismo en todas las paginas)
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    shops,
    isLoading: isLoading || isPending,
    isFetching, // 🎯 Necesario para aplicar opacidad durante refetch
    error,
    refetch,
    // Nuevas props para scroll infinito
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    // Stats útiles
    totalPages: data?.pages.length ?? 0,
    totalLocations: shops.length,
    total: totalFromApi, // Total real del API
  };
};
